import {queries} from '@/shared/integrations/zero'
import {useQuery, useSuspenseQuery} from '@rocicorp/zero/react'

export function useGetBatchesByIds(batchIds?: string[] | null) {
  return useQuery(queries.stocks.getBatchesByIds(batchIds || []))
}

export function useSuspenseGetBatchesByIds(batchIds?: string[] | null) {
  return useSuspenseQuery(queries.stocks.getBatchesByIds(batchIds || []))
}
